jQuery(function ($) {
    $(document).on('click', '.trigger', function () {
        var $this = $(this);
        // if ($this.hasClass('highest')) {
        //     $('#audio_highest')[0].currentTime = 0;
        //     $('#audio_highest')[0].play();
        // } else {
        //     $('#audio_lowest')[0].currentTime = 0;
        //     $('#audio_lowest')[0].play();
        // }

        $('#results-content .no-result').each(function () {
            $(this).addClass('queue-to-show');
        });

        $('#results-content .result').each(function () {
            $(this).addClass('queue-to-hide');
        });

        $('#results-content .queue-to-show').each(function () {
            $(this).removeClass('no-result');
        });

        $('#results-content .queue-to-hide').each(function () {
            $(this).removeClass('result');
        });

        $('#results-content .queue-to-show').each(function () {
            $(this).addClass('result').removeClass('queue-to-show');
        });

        $('#results-content .queue-to-hide').each(function () {
            $(this).addClass('no-result').removeClass('queue-to-hide');
        });

    });

    let showModal = function () {

        $('#swipe')[0].play();
        var modalid = $(this).attr('data');
        $(document).find('#modals').addClass('active').addClass('semi-opaque');
        $(document).find('#' + modalid).addClass('open');
    };
// Modals
    $(document).on('click', '.modal-trigger', function (e) {
        e.preventDefault();
        showModal.call(this);
    });

    // Modals
    $(document).on('click', '.modal .close, .modal .dismiss', function () {
        $('#swipe')[0].play();
        $(this).closest('#modals').removeClass('semi-opaque').find('.open').removeClass('open').delay(250)
            .queue(function () {
                $(document).find('#modals').removeClass('active');
                $(this).dequeue();
            });

    });

    $(document).on('click', '.scroll-pointer', function () {
        window.scrollBy({
            top: 500, // could be negative value
            left: 0,
            behavior: 'smooth'
        });
    });

    $(document).on('click', '.pdf-request-trigger', function (e) {
        e.preventDefault();
        let $this = $(this);
        $this.text('Requesting...');
        $this.prop('disabled', true);
        let xhr = axios.post($this.data('target'), {});

        xhr.then(function () {
            $this.text('Your PDF will be emailed to you shortly');
            $this.removeClass('wine').addClass('grapefruitjuice');
        });


    });

    $('body').removeClass('no-javascript');

    $('#results').addClass('loaded').filter('.with-dials').delay(750)
        .queue(function () {
            var $content = $(document).find('#results-content');
            if ($content.length) {
                $content.addClass('active');
                $(this).dequeue();
                // $('#audio_lowest')[0].play();
            }
        });


    $('.expander-toggle').on('click', function (e) {
        e.preventDefault();
        var $el = $(this);
        $el.closest('.single-score').find('.detail').slideToggle();
    });

    $(window).on('scroll', _.throttle(function () {
        $('.scroll-pointer').toggleClass('hidden', window.scrollY > 1000);
    }, 250));

    $('.collapsed-di-trigger').on('click', function () {
        // if (window.innerWidth >= 736) {
        //     var $this = $(this);
        //     $this.addClass('di-hidden');
        //     $('.fixed-di-trigger').removeClass('di-hidden');
        // } else {
        showModal.call(this);
        // }

    });

    $('#fixed_di_collapse').on('click', function () {
        $('.collapsed-di-trigger').removeClass('di-hidden');
        $('.fixed-di-trigger').addClass('di-hidden');
    });

    $(window).on('scroll', _.throttle(function () {

        let $fixed = $('.fixed-di-trigger');
        var state = $fixed.hasClass('di-hidden');
        $('.fixed-di-trigger').toggleClass('di-hidden', window.scrollY < 800);

        if (!$fixed.hasClass('di-hidden') && state) {
            $('#audio_bonetoggle')[0].play();
        }

    }, 250));


});
